<template lang="pug">
.position-relative
  .navigation
    .position-back
      .button.is-small(
        @click="$emit('prev')"
      )
        span.icon.is-small
          i.fa.fa-arrow-left
        span Previous step
  .step-title
    span Set a custom worker name

  .feature-helvetica.step-explanation
    span A worker name is required for joining our pools, it will show up on your stats. We generate a random worker name by default but you may change it to differentiate your PC / system performance on your stats.
    br 
    span A worker name must not contain spaces or special characters (besides "_" or "-")
    

  .features.address-info
    .field.has-addons
      .control.is-medium.is-expanded
        input.input.is-medium(
          type="text", 
          placeholder="", 
          v-model="worker"
          :class="{'is-danger': hasErrors}"
        )
      .control
        a.button.is-medium(@click="select", :disabled="hasErrors" :class="{'is-success': !hasErrors}")
          span Next
    p.help.help-small.notif-danger(v-if="errorWorkerMessage") {{ errorWorkerMessage }}

</template>

<script>
export default {
  name: 'c_step_worker',
  props: ['mode'],
  data () {
    return {
      worker: `unmineable_worker_${Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8)}`,
      errorWorkerMessage: ''
    }
  },
  computed: {
    hasErrors () {
      let vm = this
      return vm.errorWorkerMessage || !vm.worker
    }
  },
  watch: {
    worker: function (val) {
      var vm = this
      vm.validateWorker()
    }
  },
  created () {
    let vm = this
    if (vm.mode === 'basic') {
      vm.$emit('selected', vm.worker)
    }
  },
  mounted () {
    document.getElementById('step').scrollIntoView();
  },
  methods : {
    validateWorker () {
      let vm = this
      vm.worker = vm.worker.trim()
      if (!vm.worker.trim()) {
        vm.errorWorkerMessage = 'Your worker must not be empty'
      } else {
        let pattern = /^[0-9A-Za-z\-_]+$/gi
        if (pattern.test(vm.worker)) {
          vm.errorWorkerMessage = ''
        } else {
          vm.errorWorkerMessage = 'Your worker must not contain spaces or special characters (besides "_" or "-")'
        }
      }
    },
    select () {
      let vm = this
      if (!vm.hasErrors) {
        vm.$emit('selected', vm.worker)
      }
    }
  }
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// c_step_worker.vue?4eb52082